var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-box flex-center"},[_c('img',{attrs:{"src":require("@/assets/images/empty.png"),"alt":"no record"}})])}]

export { render, staticRenderFns }